import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=8ae2f67e&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ae2f67e')) {
      api.createRecord('8ae2f67e', component.options)
    } else {
      api.reload('8ae2f67e', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=8ae2f67e&", function () {
      api.rerender('8ae2f67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-225Jd7sYaMD7r/JS/comp/FavElement.vue"
export default component.exports